import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from '../AxiosConfig';

const MyOrg = () => {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get("/api/organizations/organization");
        setOrganization(response.data);
      } catch (err) {
        setError(err.response?.data?.error || "Error fetching organization");
      } finally {
        setLoading(false);
      }
    };

    fetchOrganization();
  }, []);

  const noHttps = (url) => {
    if (!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
    }
    return url;
  };

  const handleEditClick = () => {
    navigate('/CreateEditOrg', { state: { fromMyOrg: true } });
  };

  if (loading) {
    return (
      <Spinner animation="border" role="status" className="mt-5">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  if (error) {
    return <Alert variant="danger" className="mt-5">{error}</Alert>;
  }

  return (
    <Container className="mt-5">
      {organization ? (
        <>
          <h2 className="text-center mb-4">{organization.org_name}</h2>
          <Row>
            {/* Left Column - Organization Details */}
            <Col md={6}>
              <h4>Organization Details</h4>
              <p><strong>Branch of Organization:</strong> {organization.branch || "N/A"}</p>
              <p><strong>Website:</strong> <a href={noHttps(organization.org_url)} target="_blank" rel="noopener noreferrer">{organization.org_url}</a></p>
              <p><strong>Organization Database Website:</strong> <a href={noHttps(organization.db_url)} target="_blank" rel="noopener noreferrer">{organization.db_url || "N/A"}</a></p>
              <p><strong>Contact Person:</strong> {organization.contact_person}</p>
              <p><strong>Contact Person Role:</strong> {organization.contact_person_role}</p>
              <p><strong>Contact Email:</strong> {organization.contact_email}</p>
              <p><strong>Contact Phone:</strong> {organization.contact_phone}</p>
              <p><strong>Summary:</strong> {organization.summary}</p>
              <p><strong>For Profit:</strong> {organization.for_profit ? "Yes" : "No"}</p>
              <p>
                <strong>Country:</strong>{" "}
                {organization.countries && organization.countries.length > 0 ? (
                  organization.countries.map((country, index) => (
                    <span key={country.id}>
                      {country.name}
                      {index < organization.countries.length - 1 ? ", " : ""}
                    </span>
                  ))
                ) : (
                  <span>N/A</span>
                )}
              </p>
            </Col>

            {/* Right Column - Tag Management */}
            <Col md={6}>
              <h4>Organization Tags</h4>

              <p><strong>Data My Organization Collects</strong></p>
              {organization.my_org_tags && organization.my_org_tags.length > 0 ? (
                <ul>
                  {organization.my_org_tags.map((tag) => (
                    <li key={tag.id}>{tag.name}</li>
                  ))}
                </ul>
              ) : (
                <p>N/A</p>
              )}

              <p><strong>Collaborative Interests</strong></p>
              {organization.collaborative && organization.collaborative.length > 0 ? (
                <ul>
                  {organization.collaborative.map((tag) => (
                    <li key={tag.id}>{tag.name}</li>
                  ))}
                </ul>
              ) : (
                <p>N/A</p>
              )}

              <p><strong>Regions</strong></p>
              {organization.regions && organization.regions.length > 0 ? (
                <ul>
                  {organization.regions.map((region) => (
                    <li key={region.id}>{region.name}</li>
                  ))}
                </ul>
              ) : (
                <p>N/A</p>
              )}
            </Col>
          </Row>
          <div className="d-flex justify-content-center mt-4 mb-4">
            <Button variant="primary" onClick={handleEditClick}>Edit Organization</Button>
          </div>
        </>
      ) : (
        <Alert variant="warning" className="mt-5">No organization found for this user.</Alert>
      )}
    </Container>
  );
};

export default MyOrg;
